/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedSplatRouteImport } from './routes/_authenticated/$'
import { Route as AuthenticatedOrgsOrganizationIdRouteImport } from './routes/_authenticated/orgs/$organizationId'
import { Route as AuthenticatedOrgsOrganizationIdIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsRouteImport } from './routes/_authenticated/orgs/$organizationId/projects'
import { Route as AuthenticatedOrgsOrganizationIdProjectsIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdWelcomeRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/welcome'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdUserSourcesRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/user-sources'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdToolsRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/tools'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdToolkitsRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/toolkits'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/servers'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectsRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/projects'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/playground'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/onboarding'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdMcpGatewaysRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/mcp-gateways'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdHomeRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/home'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/billing'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdAuditLogsRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/audit-logs'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdApiKeysRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/api-keys'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/settings/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdServersIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/servers/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/playground/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/invitations/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/billing/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/auth/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsUserVerificationRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/settings/user-verification'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdServersServerIdRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/servers/$serverId'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectMembersRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/project/members'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundExecuteRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/playground/execute'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingFirstCallRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/first-call'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingConnectRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/connect'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsInvitationIdRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/invitations/$invitationId'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessNewRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/new'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessPluginIdRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/$pluginId'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingOverviewRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/billing/overview'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingInvoicesRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/billing/invoices'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSettingsRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/auth/settings'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthConnectedUsersRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/auth/connected-users'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatChatIdRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat/$chatId'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/processing'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsSecretIdRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets/$secretId'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthOauthIdRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth/$oauthId'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutIndexRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/index'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingPlanIdRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/processing/$planId'
import { Route as AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutPlanIdRouteImport } from './routes/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/$planId'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrgsOrganizationIdRoute =
  AuthenticatedOrgsOrganizationIdRouteImport.update({
    id: '/orgs/$organizationId',
    path: '/orgs/$organizationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdIndexRoute =
  AuthenticatedOrgsOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsRoute =
  AuthenticatedOrgsOrganizationIdProjectsRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdWelcomeRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdWelcomeRouteImport.update({
    id: '/welcome',
    path: '/welcome',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdUserSourcesRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdUserSourcesRouteImport.update(
    {
      id: '/user-sources',
      path: '/user-sources',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdToolsRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdToolsRouteImport.update({
    id: '/tools',
    path: '/tools',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdToolkitsRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdToolkitsRouteImport.update({
    id: '/toolkits',
    path: '/toolkits',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRouteImport.update({
    id: '/servers',
    path: '/servers',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectsRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectsRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRouteImport.update({
    id: '/playground',
    path: '/playground',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdMcpGatewaysRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdMcpGatewaysRouteImport.update(
    {
      id: '/mcp-gateways',
      path: '/mcp-gateways',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdHomeRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdHomeRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRouteImport.update(
    {
      id: '/contextual-access',
      path: '/contextual-access',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdAuditLogsRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuditLogsRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdApiKeysRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsIndexRouteImport.update(
    {
      id: '/settings/',
      path: '/settings/',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdServersIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdServersIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsIndexRouteImport.update(
    {
      id: '/invitations/',
      path: '/invitations/',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthIndexRouteImport.update({
    id: '/auth/',
    path: '/auth/',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsUserVerificationRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsUserVerificationRouteImport.update(
    {
      id: '/settings/user-verification',
      path: '/settings/user-verification',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdServersServerIdRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdServersServerIdRouteImport.update(
    {
      id: '/$serverId',
      path: '/$serverId',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectMembersRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectMembersRouteImport.update(
    {
      id: '/project/members',
      path: '/project/members',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundExecuteRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundExecuteRouteImport.update(
    {
      id: '/execute',
      path: '/execute',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRouteImport.update(
    {
      id: '/chat',
      path: '/chat',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingFirstCallRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingFirstCallRouteImport.update(
    {
      id: '/first-call',
      path: '/first-call',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingConnectRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingConnectRouteImport.update(
    {
      id: '/connect',
      path: '/connect',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsInvitationIdRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsInvitationIdRouteImport.update(
    {
      id: '/invitations/$invitationId',
      path: '/invitations/$invitationId',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessNewRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessNewRouteImport.update(
    {
      id: '/new',
      path: '/new',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessPluginIdRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessPluginIdRouteImport.update(
    {
      id: '/$pluginId',
      path: '/$pluginId',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRouteImport.update(
    {
      id: '/upgrade',
      path: '/upgrade',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingOverviewRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingInvoicesRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingInvoicesRouteImport.update(
    {
      id: '/invoices',
      path: '/invoices',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSettingsRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSettingsRouteImport.update(
    {
      id: '/auth/settings',
      path: '/auth/settings',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRouteImport.update(
    {
      id: '/auth/secrets',
      path: '/auth/secrets',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRouteImport.update({
    id: '/auth/oauth',
    path: '/auth/oauth',
    getParentRoute: () => AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
  } as any)
const AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthConnectedUsersRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthConnectedUsersRouteImport.update(
    {
      id: '/auth/connected-users',
      path: '/auth/connected-users',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatChatIdRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatChatIdRouteImport.update(
    {
      id: '/$chatId',
      path: '/$chatId',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRouteImport.update(
    {
      id: '/processing',
      path: '/processing',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRouteImport.update(
    {
      id: '/checkout',
      path: '/checkout',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsSecretIdRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsSecretIdRouteImport.update(
    {
      id: '/$secretId',
      path: '/$secretId',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthOauthIdRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthOauthIdRouteImport.update(
    {
      id: '/$oauthId',
      path: '/$oauthId',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutIndexRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingPlanIdRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingPlanIdRouteImport.update(
    {
      id: '/$planId',
      path: '/$planId',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRoute,
    } as any,
  )
const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutPlanIdRoute =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutPlanIdRouteImport.update(
    {
      id: '/$planId',
      path: '/$planId',
      getParentRoute: () =>
        AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/$': typeof AuthenticatedSplatRoute
  '/orgs/$organizationId': typeof AuthenticatedOrgsOrganizationIdRouteWithChildren
  '/orgs/$organizationId/projects': typeof AuthenticatedOrgsOrganizationIdProjectsRouteWithChildren
  '/orgs/$organizationId/': typeof AuthenticatedOrgsOrganizationIdIndexRoute
  '/orgs/$organizationId/projects/$projectId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRouteWithChildren
  '/orgs/$organizationId/projects/': typeof AuthenticatedOrgsOrganizationIdProjectsIndexRoute
  '/orgs/$organizationId/projects/$projectId/api-keys': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdApiKeysRoute
  '/orgs/$organizationId/projects/$projectId/audit-logs': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuditLogsRoute
  '/orgs/$organizationId/projects/$projectId/billing': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRouteWithChildren
  '/orgs/$organizationId/projects/$projectId/contextual-access': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRouteWithChildren
  '/orgs/$organizationId/projects/$projectId/home': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdHomeRoute
  '/orgs/$organizationId/projects/$projectId/mcp-gateways': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdMcpGatewaysRoute
  '/orgs/$organizationId/projects/$projectId/onboarding': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRouteWithChildren
  '/orgs/$organizationId/projects/$projectId/playground': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRouteWithChildren
  '/orgs/$organizationId/projects/$projectId/projects': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectsRoute
  '/orgs/$organizationId/projects/$projectId/servers': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRouteWithChildren
  '/orgs/$organizationId/projects/$projectId/toolkits': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdToolkitsRoute
  '/orgs/$organizationId/projects/$projectId/tools': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdToolsRoute
  '/orgs/$organizationId/projects/$projectId/user-sources': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdUserSourcesRoute
  '/orgs/$organizationId/projects/$projectId/welcome': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdWelcomeRoute
  '/orgs/$organizationId/projects/$projectId/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdIndexRoute
  '/orgs/$organizationId/projects/$projectId/auth/connected-users': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthConnectedUsersRoute
  '/orgs/$organizationId/projects/$projectId/auth/oauth': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRouteWithChildren
  '/orgs/$organizationId/projects/$projectId/auth/secrets': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRouteWithChildren
  '/orgs/$organizationId/projects/$projectId/auth/settings': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSettingsRoute
  '/orgs/$organizationId/projects/$projectId/billing/invoices': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingInvoicesRoute
  '/orgs/$organizationId/projects/$projectId/billing/overview': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingOverviewRoute
  '/orgs/$organizationId/projects/$projectId/billing/upgrade': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRouteWithChildren
  '/orgs/$organizationId/projects/$projectId/contextual-access/$pluginId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessPluginIdRoute
  '/orgs/$organizationId/projects/$projectId/contextual-access/new': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessNewRoute
  '/orgs/$organizationId/projects/$projectId/invitations/$invitationId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsInvitationIdRoute
  '/orgs/$organizationId/projects/$projectId/onboarding/connect': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingConnectRoute
  '/orgs/$organizationId/projects/$projectId/onboarding/first-call': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingFirstCallRoute
  '/orgs/$organizationId/projects/$projectId/playground/chat': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRouteWithChildren
  '/orgs/$organizationId/projects/$projectId/playground/execute': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundExecuteRoute
  '/orgs/$organizationId/projects/$projectId/project/members': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectMembersRoute
  '/orgs/$organizationId/projects/$projectId/servers/$serverId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersServerIdRoute
  '/orgs/$organizationId/projects/$projectId/settings/user-verification': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsUserVerificationRoute
  '/orgs/$organizationId/projects/$projectId/auth/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthIndexRoute
  '/orgs/$organizationId/projects/$projectId/billing/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingIndexRoute
  '/orgs/$organizationId/projects/$projectId/contextual-access/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessIndexRoute
  '/orgs/$organizationId/projects/$projectId/invitations/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsIndexRoute
  '/orgs/$organizationId/projects/$projectId/onboarding/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingIndexRoute
  '/orgs/$organizationId/projects/$projectId/playground/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundIndexRoute
  '/orgs/$organizationId/projects/$projectId/servers/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersIndexRoute
  '/orgs/$organizationId/projects/$projectId/settings/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsIndexRoute
  '/orgs/$organizationId/projects/$projectId/auth/oauth/$oauthId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthOauthIdRoute
  '/orgs/$organizationId/projects/$projectId/auth/secrets/$secretId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsSecretIdRoute
  '/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRouteWithChildren
  '/orgs/$organizationId/projects/$projectId/billing/upgrade/processing': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRouteWithChildren
  '/orgs/$organizationId/projects/$projectId/playground/chat/$chatId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatChatIdRoute
  '/orgs/$organizationId/projects/$projectId/auth/oauth/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthIndexRoute
  '/orgs/$organizationId/projects/$projectId/auth/secrets/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsIndexRoute
  '/orgs/$organizationId/projects/$projectId/billing/upgrade/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeIndexRoute
  '/orgs/$organizationId/projects/$projectId/playground/chat/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatIndexRoute
  '/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/$planId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutPlanIdRoute
  '/orgs/$organizationId/projects/$projectId/billing/upgrade/processing/$planId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingPlanIdRoute
  '/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/$': typeof AuthenticatedSplatRoute
  '/': typeof AuthenticatedIndexRoute
  '/orgs/$organizationId': typeof AuthenticatedOrgsOrganizationIdIndexRoute
  '/orgs/$organizationId/projects': typeof AuthenticatedOrgsOrganizationIdProjectsIndexRoute
  '/orgs/$organizationId/projects/$projectId/api-keys': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdApiKeysRoute
  '/orgs/$organizationId/projects/$projectId/audit-logs': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuditLogsRoute
  '/orgs/$organizationId/projects/$projectId/home': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdHomeRoute
  '/orgs/$organizationId/projects/$projectId/mcp-gateways': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdMcpGatewaysRoute
  '/orgs/$organizationId/projects/$projectId/projects': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectsRoute
  '/orgs/$organizationId/projects/$projectId/toolkits': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdToolkitsRoute
  '/orgs/$organizationId/projects/$projectId/tools': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdToolsRoute
  '/orgs/$organizationId/projects/$projectId/user-sources': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdUserSourcesRoute
  '/orgs/$organizationId/projects/$projectId/welcome': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdWelcomeRoute
  '/orgs/$organizationId/projects/$projectId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdIndexRoute
  '/orgs/$organizationId/projects/$projectId/auth/connected-users': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthConnectedUsersRoute
  '/orgs/$organizationId/projects/$projectId/auth/settings': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSettingsRoute
  '/orgs/$organizationId/projects/$projectId/billing/invoices': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingInvoicesRoute
  '/orgs/$organizationId/projects/$projectId/billing/overview': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingOverviewRoute
  '/orgs/$organizationId/projects/$projectId/contextual-access/$pluginId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessPluginIdRoute
  '/orgs/$organizationId/projects/$projectId/contextual-access/new': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessNewRoute
  '/orgs/$organizationId/projects/$projectId/invitations/$invitationId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsInvitationIdRoute
  '/orgs/$organizationId/projects/$projectId/onboarding/connect': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingConnectRoute
  '/orgs/$organizationId/projects/$projectId/onboarding/first-call': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingFirstCallRoute
  '/orgs/$organizationId/projects/$projectId/playground/execute': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundExecuteRoute
  '/orgs/$organizationId/projects/$projectId/project/members': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectMembersRoute
  '/orgs/$organizationId/projects/$projectId/servers/$serverId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersServerIdRoute
  '/orgs/$organizationId/projects/$projectId/settings/user-verification': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsUserVerificationRoute
  '/orgs/$organizationId/projects/$projectId/auth': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthIndexRoute
  '/orgs/$organizationId/projects/$projectId/billing': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingIndexRoute
  '/orgs/$organizationId/projects/$projectId/contextual-access': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessIndexRoute
  '/orgs/$organizationId/projects/$projectId/invitations': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsIndexRoute
  '/orgs/$organizationId/projects/$projectId/onboarding': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingIndexRoute
  '/orgs/$organizationId/projects/$projectId/playground': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundIndexRoute
  '/orgs/$organizationId/projects/$projectId/servers': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersIndexRoute
  '/orgs/$organizationId/projects/$projectId/settings': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsIndexRoute
  '/orgs/$organizationId/projects/$projectId/auth/oauth/$oauthId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthOauthIdRoute
  '/orgs/$organizationId/projects/$projectId/auth/secrets/$secretId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsSecretIdRoute
  '/orgs/$organizationId/projects/$projectId/billing/upgrade/processing': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRouteWithChildren
  '/orgs/$organizationId/projects/$projectId/playground/chat/$chatId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatChatIdRoute
  '/orgs/$organizationId/projects/$projectId/auth/oauth': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthIndexRoute
  '/orgs/$organizationId/projects/$projectId/auth/secrets': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsIndexRoute
  '/orgs/$organizationId/projects/$projectId/billing/upgrade': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeIndexRoute
  '/orgs/$organizationId/projects/$projectId/playground/chat': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatIndexRoute
  '/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/$planId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutPlanIdRoute
  '/orgs/$organizationId/projects/$projectId/billing/upgrade/processing/$planId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingPlanIdRoute
  '/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/_authenticated/$': typeof AuthenticatedSplatRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/orgs/$organizationId': typeof AuthenticatedOrgsOrganizationIdRouteWithChildren
  '/_authenticated/orgs/$organizationId/projects': typeof AuthenticatedOrgsOrganizationIdProjectsRouteWithChildren
  '/_authenticated/orgs/$organizationId/': typeof AuthenticatedOrgsOrganizationIdIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRouteWithChildren
  '/_authenticated/orgs/$organizationId/projects/': typeof AuthenticatedOrgsOrganizationIdProjectsIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/api-keys': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdApiKeysRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/audit-logs': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuditLogsRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/billing': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRouteWithChildren
  '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRouteWithChildren
  '/_authenticated/orgs/$organizationId/projects/$projectId/home': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdHomeRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/mcp-gateways': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdMcpGatewaysRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRouteWithChildren
  '/_authenticated/orgs/$organizationId/projects/$projectId/playground': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRouteWithChildren
  '/_authenticated/orgs/$organizationId/projects/$projectId/projects': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectsRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/servers': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRouteWithChildren
  '/_authenticated/orgs/$organizationId/projects/$projectId/toolkits': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdToolkitsRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/tools': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdToolsRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/user-sources': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdUserSourcesRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/welcome': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdWelcomeRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/auth/connected-users': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthConnectedUsersRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRouteWithChildren
  '/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRouteWithChildren
  '/_authenticated/orgs/$organizationId/projects/$projectId/auth/settings': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSettingsRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/billing/invoices': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingInvoicesRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/billing/overview': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingOverviewRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRouteWithChildren
  '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/$pluginId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessPluginIdRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/new': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessNewRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/invitations/$invitationId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsInvitationIdRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/connect': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingConnectRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/first-call': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingFirstCallRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRouteWithChildren
  '/_authenticated/orgs/$organizationId/projects/$projectId/playground/execute': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundExecuteRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/project/members': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectMembersRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/servers/$serverId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersServerIdRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/settings/user-verification': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsUserVerificationRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/auth/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/billing/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/invitations/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/playground/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/servers/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/settings/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth/$oauthId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthOauthIdRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets/$secretId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsSecretIdRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRouteWithChildren
  '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/processing': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRouteWithChildren
  '/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat/$chatId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatChatIdRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatIndexRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/$planId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutPlanIdRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/processing/$planId': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingPlanIdRoute
  '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/': typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/$'
    | '/orgs/$organizationId'
    | '/orgs/$organizationId/projects'
    | '/orgs/$organizationId/'
    | '/orgs/$organizationId/projects/$projectId'
    | '/orgs/$organizationId/projects/'
    | '/orgs/$organizationId/projects/$projectId/api-keys'
    | '/orgs/$organizationId/projects/$projectId/audit-logs'
    | '/orgs/$organizationId/projects/$projectId/billing'
    | '/orgs/$organizationId/projects/$projectId/contextual-access'
    | '/orgs/$organizationId/projects/$projectId/home'
    | '/orgs/$organizationId/projects/$projectId/mcp-gateways'
    | '/orgs/$organizationId/projects/$projectId/onboarding'
    | '/orgs/$organizationId/projects/$projectId/playground'
    | '/orgs/$organizationId/projects/$projectId/projects'
    | '/orgs/$organizationId/projects/$projectId/servers'
    | '/orgs/$organizationId/projects/$projectId/toolkits'
    | '/orgs/$organizationId/projects/$projectId/tools'
    | '/orgs/$organizationId/projects/$projectId/user-sources'
    | '/orgs/$organizationId/projects/$projectId/welcome'
    | '/orgs/$organizationId/projects/$projectId/'
    | '/orgs/$organizationId/projects/$projectId/auth/connected-users'
    | '/orgs/$organizationId/projects/$projectId/auth/oauth'
    | '/orgs/$organizationId/projects/$projectId/auth/secrets'
    | '/orgs/$organizationId/projects/$projectId/auth/settings'
    | '/orgs/$organizationId/projects/$projectId/billing/invoices'
    | '/orgs/$organizationId/projects/$projectId/billing/overview'
    | '/orgs/$organizationId/projects/$projectId/billing/upgrade'
    | '/orgs/$organizationId/projects/$projectId/contextual-access/$pluginId'
    | '/orgs/$organizationId/projects/$projectId/contextual-access/new'
    | '/orgs/$organizationId/projects/$projectId/invitations/$invitationId'
    | '/orgs/$organizationId/projects/$projectId/onboarding/connect'
    | '/orgs/$organizationId/projects/$projectId/onboarding/first-call'
    | '/orgs/$organizationId/projects/$projectId/playground/chat'
    | '/orgs/$organizationId/projects/$projectId/playground/execute'
    | '/orgs/$organizationId/projects/$projectId/project/members'
    | '/orgs/$organizationId/projects/$projectId/servers/$serverId'
    | '/orgs/$organizationId/projects/$projectId/settings/user-verification'
    | '/orgs/$organizationId/projects/$projectId/auth/'
    | '/orgs/$organizationId/projects/$projectId/billing/'
    | '/orgs/$organizationId/projects/$projectId/contextual-access/'
    | '/orgs/$organizationId/projects/$projectId/invitations/'
    | '/orgs/$organizationId/projects/$projectId/onboarding/'
    | '/orgs/$organizationId/projects/$projectId/playground/'
    | '/orgs/$organizationId/projects/$projectId/servers/'
    | '/orgs/$organizationId/projects/$projectId/settings/'
    | '/orgs/$organizationId/projects/$projectId/auth/oauth/$oauthId'
    | '/orgs/$organizationId/projects/$projectId/auth/secrets/$secretId'
    | '/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout'
    | '/orgs/$organizationId/projects/$projectId/billing/upgrade/processing'
    | '/orgs/$organizationId/projects/$projectId/playground/chat/$chatId'
    | '/orgs/$organizationId/projects/$projectId/auth/oauth/'
    | '/orgs/$organizationId/projects/$projectId/auth/secrets/'
    | '/orgs/$organizationId/projects/$projectId/billing/upgrade/'
    | '/orgs/$organizationId/projects/$projectId/playground/chat/'
    | '/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/$planId'
    | '/orgs/$organizationId/projects/$projectId/billing/upgrade/processing/$planId'
    | '/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/register'
    | '/$'
    | '/'
    | '/orgs/$organizationId'
    | '/orgs/$organizationId/projects'
    | '/orgs/$organizationId/projects/$projectId/api-keys'
    | '/orgs/$organizationId/projects/$projectId/audit-logs'
    | '/orgs/$organizationId/projects/$projectId/home'
    | '/orgs/$organizationId/projects/$projectId/mcp-gateways'
    | '/orgs/$organizationId/projects/$projectId/projects'
    | '/orgs/$organizationId/projects/$projectId/toolkits'
    | '/orgs/$organizationId/projects/$projectId/tools'
    | '/orgs/$organizationId/projects/$projectId/user-sources'
    | '/orgs/$organizationId/projects/$projectId/welcome'
    | '/orgs/$organizationId/projects/$projectId'
    | '/orgs/$organizationId/projects/$projectId/auth/connected-users'
    | '/orgs/$organizationId/projects/$projectId/auth/settings'
    | '/orgs/$organizationId/projects/$projectId/billing/invoices'
    | '/orgs/$organizationId/projects/$projectId/billing/overview'
    | '/orgs/$organizationId/projects/$projectId/contextual-access/$pluginId'
    | '/orgs/$organizationId/projects/$projectId/contextual-access/new'
    | '/orgs/$organizationId/projects/$projectId/invitations/$invitationId'
    | '/orgs/$organizationId/projects/$projectId/onboarding/connect'
    | '/orgs/$organizationId/projects/$projectId/onboarding/first-call'
    | '/orgs/$organizationId/projects/$projectId/playground/execute'
    | '/orgs/$organizationId/projects/$projectId/project/members'
    | '/orgs/$organizationId/projects/$projectId/servers/$serverId'
    | '/orgs/$organizationId/projects/$projectId/settings/user-verification'
    | '/orgs/$organizationId/projects/$projectId/auth'
    | '/orgs/$organizationId/projects/$projectId/billing'
    | '/orgs/$organizationId/projects/$projectId/contextual-access'
    | '/orgs/$organizationId/projects/$projectId/invitations'
    | '/orgs/$organizationId/projects/$projectId/onboarding'
    | '/orgs/$organizationId/projects/$projectId/playground'
    | '/orgs/$organizationId/projects/$projectId/servers'
    | '/orgs/$organizationId/projects/$projectId/settings'
    | '/orgs/$organizationId/projects/$projectId/auth/oauth/$oauthId'
    | '/orgs/$organizationId/projects/$projectId/auth/secrets/$secretId'
    | '/orgs/$organizationId/projects/$projectId/billing/upgrade/processing'
    | '/orgs/$organizationId/projects/$projectId/playground/chat/$chatId'
    | '/orgs/$organizationId/projects/$projectId/auth/oauth'
    | '/orgs/$organizationId/projects/$projectId/auth/secrets'
    | '/orgs/$organizationId/projects/$projectId/billing/upgrade'
    | '/orgs/$organizationId/projects/$projectId/playground/chat'
    | '/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/$planId'
    | '/orgs/$organizationId/projects/$projectId/billing/upgrade/processing/$planId'
    | '/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/register'
    | '/_authenticated/$'
    | '/_authenticated/'
    | '/_authenticated/orgs/$organizationId'
    | '/_authenticated/orgs/$organizationId/projects'
    | '/_authenticated/orgs/$organizationId/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId'
    | '/_authenticated/orgs/$organizationId/projects/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/api-keys'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/audit-logs'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/billing'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/home'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/mcp-gateways'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/playground'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/projects'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/servers'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/toolkits'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/tools'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/user-sources'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/welcome'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/auth/connected-users'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/auth/settings'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/billing/invoices'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/billing/overview'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/$pluginId'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/new'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/invitations/$invitationId'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/connect'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/first-call'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/playground/execute'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/project/members'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/servers/$serverId'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/settings/user-verification'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/auth/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/billing/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/invitations/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/playground/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/servers/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/settings/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth/$oauthId'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets/$secretId'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/processing'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat/$chatId'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat/'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/$planId'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/processing/$planId'
    | '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$': {
      id: '/_authenticated/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthenticatedSplatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orgs/$organizationId': {
      id: '/_authenticated/orgs/$organizationId'
      path: '/orgs/$organizationId'
      fullPath: '/orgs/$organizationId'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orgs/$organizationId/': {
      id: '/_authenticated/orgs/$organizationId/'
      path: '/'
      fullPath: '/orgs/$organizationId/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects': {
      id: '/_authenticated/orgs/$organizationId/projects'
      path: '/projects'
      fullPath: '/orgs/$organizationId/projects'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/': {
      id: '/_authenticated/orgs/$organizationId/projects/'
      path: '/'
      fullPath: '/orgs/$organizationId/projects/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId'
      path: '/$projectId'
      fullPath: '/orgs/$organizationId/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/'
      path: '/'
      fullPath: '/orgs/$organizationId/projects/$projectId/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/welcome': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/welcome'
      path: '/welcome'
      fullPath: '/orgs/$organizationId/projects/$projectId/welcome'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdWelcomeRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/user-sources': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/user-sources'
      path: '/user-sources'
      fullPath: '/orgs/$organizationId/projects/$projectId/user-sources'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdUserSourcesRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/tools': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/tools'
      path: '/tools'
      fullPath: '/orgs/$organizationId/projects/$projectId/tools'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdToolsRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/toolkits': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/toolkits'
      path: '/toolkits'
      fullPath: '/orgs/$organizationId/projects/$projectId/toolkits'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdToolkitsRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/servers': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/servers'
      path: '/servers'
      fullPath: '/orgs/$organizationId/projects/$projectId/servers'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/projects': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/projects'
      path: '/projects'
      fullPath: '/orgs/$organizationId/projects/$projectId/projects'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectsRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/playground': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/playground'
      path: '/playground'
      fullPath: '/orgs/$organizationId/projects/$projectId/playground'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding'
      path: '/onboarding'
      fullPath: '/orgs/$organizationId/projects/$projectId/onboarding'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/mcp-gateways': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/mcp-gateways'
      path: '/mcp-gateways'
      fullPath: '/orgs/$organizationId/projects/$projectId/mcp-gateways'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdMcpGatewaysRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/home': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/home'
      path: '/home'
      fullPath: '/orgs/$organizationId/projects/$projectId/home'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdHomeRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access'
      path: '/contextual-access'
      fullPath: '/orgs/$organizationId/projects/$projectId/contextual-access'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/billing': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/billing'
      path: '/billing'
      fullPath: '/orgs/$organizationId/projects/$projectId/billing'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/audit-logs': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/audit-logs'
      path: '/audit-logs'
      fullPath: '/orgs/$organizationId/projects/$projectId/audit-logs'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuditLogsRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/api-keys': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/api-keys'
      path: '/api-keys'
      fullPath: '/orgs/$organizationId/projects/$projectId/api-keys'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdApiKeysRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/settings/': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/settings/'
      path: '/settings'
      fullPath: '/orgs/$organizationId/projects/$projectId/settings/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/servers/': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/servers/'
      path: '/'
      fullPath: '/orgs/$organizationId/projects/$projectId/servers/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/playground/': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/playground/'
      path: '/'
      fullPath: '/orgs/$organizationId/projects/$projectId/playground/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/'
      path: '/'
      fullPath: '/orgs/$organizationId/projects/$projectId/onboarding/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/invitations/': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/invitations/'
      path: '/invitations'
      fullPath: '/orgs/$organizationId/projects/$projectId/invitations/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/'
      path: '/'
      fullPath: '/orgs/$organizationId/projects/$projectId/contextual-access/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/billing/': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/billing/'
      path: '/'
      fullPath: '/orgs/$organizationId/projects/$projectId/billing/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/auth/': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/auth/'
      path: '/auth'
      fullPath: '/orgs/$organizationId/projects/$projectId/auth/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/settings/user-verification': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/settings/user-verification'
      path: '/settings/user-verification'
      fullPath: '/orgs/$organizationId/projects/$projectId/settings/user-verification'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsUserVerificationRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/servers/$serverId': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/servers/$serverId'
      path: '/$serverId'
      fullPath: '/orgs/$organizationId/projects/$projectId/servers/$serverId'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersServerIdRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/project/members': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/project/members'
      path: '/project/members'
      fullPath: '/orgs/$organizationId/projects/$projectId/project/members'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectMembersRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/playground/execute': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/playground/execute'
      path: '/execute'
      fullPath: '/orgs/$organizationId/projects/$projectId/playground/execute'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundExecuteRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat'
      path: '/chat'
      fullPath: '/orgs/$organizationId/projects/$projectId/playground/chat'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/first-call': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/first-call'
      path: '/first-call'
      fullPath: '/orgs/$organizationId/projects/$projectId/onboarding/first-call'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingFirstCallRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/connect': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/connect'
      path: '/connect'
      fullPath: '/orgs/$organizationId/projects/$projectId/onboarding/connect'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingConnectRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/invitations/$invitationId': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/invitations/$invitationId'
      path: '/invitations/$invitationId'
      fullPath: '/orgs/$organizationId/projects/$projectId/invitations/$invitationId'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsInvitationIdRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/new': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/new'
      path: '/new'
      fullPath: '/orgs/$organizationId/projects/$projectId/contextual-access/new'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessNewRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/$pluginId': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/$pluginId'
      path: '/$pluginId'
      fullPath: '/orgs/$organizationId/projects/$projectId/contextual-access/$pluginId'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessPluginIdRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade'
      path: '/upgrade'
      fullPath: '/orgs/$organizationId/projects/$projectId/billing/upgrade'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/billing/overview': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/billing/overview'
      path: '/overview'
      fullPath: '/orgs/$organizationId/projects/$projectId/billing/overview'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingOverviewRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/billing/invoices': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/billing/invoices'
      path: '/invoices'
      fullPath: '/orgs/$organizationId/projects/$projectId/billing/invoices'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingInvoicesRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/auth/settings': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/auth/settings'
      path: '/auth/settings'
      fullPath: '/orgs/$organizationId/projects/$projectId/auth/settings'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSettingsRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets'
      path: '/auth/secrets'
      fullPath: '/orgs/$organizationId/projects/$projectId/auth/secrets'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth'
      path: '/auth/oauth'
      fullPath: '/orgs/$organizationId/projects/$projectId/auth/oauth'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/auth/connected-users': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/auth/connected-users'
      path: '/auth/connected-users'
      fullPath: '/orgs/$organizationId/projects/$projectId/auth/connected-users'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthConnectedUsersRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat/': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat/'
      path: '/'
      fullPath: '/orgs/$organizationId/projects/$projectId/playground/chat/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/'
      path: '/'
      fullPath: '/orgs/$organizationId/projects/$projectId/billing/upgrade/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets/': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets/'
      path: '/'
      fullPath: '/orgs/$organizationId/projects/$projectId/auth/secrets/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth/': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth/'
      path: '/'
      fullPath: '/orgs/$organizationId/projects/$projectId/auth/oauth/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat/$chatId': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/playground/chat/$chatId'
      path: '/$chatId'
      fullPath: '/orgs/$organizationId/projects/$projectId/playground/chat/$chatId'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatChatIdRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/processing': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/processing'
      path: '/processing'
      fullPath: '/orgs/$organizationId/projects/$projectId/billing/upgrade/processing'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout'
      path: '/checkout'
      fullPath: '/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets/$secretId': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets/$secretId'
      path: '/$secretId'
      fullPath: '/orgs/$organizationId/projects/$projectId/auth/secrets/$secretId'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsSecretIdRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth/$oauthId': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth/$oauthId'
      path: '/$oauthId'
      fullPath: '/orgs/$organizationId/projects/$projectId/auth/oauth/$oauthId'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthOauthIdRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/'
      path: '/'
      fullPath: '/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutIndexRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/processing/$planId': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/processing/$planId'
      path: '/$planId'
      fullPath: '/orgs/$organizationId/projects/$projectId/billing/upgrade/processing/$planId'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingPlanIdRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRoute
    }
    '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/$planId': {
      id: '/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/$planId'
      path: '/$planId'
      fullPath: '/orgs/$organizationId/projects/$projectId/billing/upgrade/checkout/$planId'
      preLoaderRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutPlanIdRouteImport
      parentRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRoute
    }
  }
}

interface AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRouteChildren {
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutPlanIdRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutPlanIdRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutIndexRoute
}

const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRouteChildren: AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRouteChildren =
  {
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutPlanIdRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutPlanIdRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutIndexRoute,
  }

const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRouteWithChildren =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRoute._addFileChildren(
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRouteChildren,
  )

interface AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRouteChildren {
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingPlanIdRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingPlanIdRoute
}

const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRouteChildren: AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRouteChildren =
  {
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingPlanIdRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingPlanIdRoute,
  }

const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRouteWithChildren =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRoute._addFileChildren(
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRouteChildren,
  )

interface AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRouteChildren {
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRouteWithChildren
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRouteWithChildren
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeIndexRoute
}

const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRouteChildren: AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRouteChildren =
  {
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeCheckoutRouteWithChildren,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeProcessingRouteWithChildren,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeIndexRoute,
  }

const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRouteWithChildren =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRoute._addFileChildren(
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRouteChildren,
  )

interface AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRouteChildren {
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingInvoicesRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingInvoicesRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingOverviewRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingOverviewRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRouteWithChildren
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingIndexRoute
}

const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRouteChildren: AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRouteChildren =
  {
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingInvoicesRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingInvoicesRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingOverviewRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingOverviewRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingUpgradeRouteWithChildren,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingIndexRoute,
  }

const AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRouteWithChildren =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRoute._addFileChildren(
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRouteChildren,
  )

interface AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRouteChildren {
  AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessPluginIdRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessPluginIdRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessNewRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessNewRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessIndexRoute
}

const AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRouteChildren: AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRouteChildren =
  {
    AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessPluginIdRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessPluginIdRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessNewRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessNewRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessIndexRoute,
  }

const AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRouteWithChildren =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRoute._addFileChildren(
    AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRouteChildren,
  )

interface AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRouteChildren {
  AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingConnectRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingConnectRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingFirstCallRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingFirstCallRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingIndexRoute
}

const AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRouteChildren: AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRouteChildren =
  {
    AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingConnectRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingConnectRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingFirstCallRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingFirstCallRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingIndexRoute,
  }

const AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRouteWithChildren =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRoute._addFileChildren(
    AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRouteChildren,
  )

interface AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRouteChildren {
  AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatChatIdRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatChatIdRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatIndexRoute
}

const AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRouteChildren: AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRouteChildren =
  {
    AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatChatIdRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatChatIdRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatIndexRoute,
  }

const AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRouteWithChildren =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRoute._addFileChildren(
    AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRouteChildren,
  )

interface AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRouteChildren {
  AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRouteWithChildren
  AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundExecuteRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundExecuteRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundIndexRoute
}

const AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRouteChildren: AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRouteChildren =
  {
    AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundChatRouteWithChildren,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundExecuteRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundExecuteRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundIndexRoute,
  }

const AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRouteWithChildren =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRoute._addFileChildren(
    AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRouteChildren,
  )

interface AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRouteChildren {
  AuthenticatedOrgsOrganizationIdProjectsProjectIdServersServerIdRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersServerIdRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdServersIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersIndexRoute
}

const AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRouteChildren: AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRouteChildren =
  {
    AuthenticatedOrgsOrganizationIdProjectsProjectIdServersServerIdRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdServersServerIdRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdServersIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdServersIndexRoute,
  }

const AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRouteWithChildren =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRoute._addFileChildren(
    AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRouteChildren,
  )

interface AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRouteChildren {
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthOauthIdRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthOauthIdRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthIndexRoute
}

const AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRouteChildren: AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRouteChildren =
  {
    AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthOauthIdRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthOauthIdRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthIndexRoute,
  }

const AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRouteWithChildren =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRoute._addFileChildren(
    AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRouteChildren,
  )

interface AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRouteChildren {
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsSecretIdRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsSecretIdRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsIndexRoute
}

const AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRouteChildren: AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRouteChildren =
  {
    AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsSecretIdRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsSecretIdRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsIndexRoute,
  }

const AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRouteWithChildren =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRoute._addFileChildren(
    AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRouteChildren,
  )

interface AuthenticatedOrgsOrganizationIdProjectsProjectIdRouteChildren {
  AuthenticatedOrgsOrganizationIdProjectsProjectIdApiKeysRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdApiKeysRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuditLogsRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuditLogsRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRouteWithChildren
  AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRouteWithChildren
  AuthenticatedOrgsOrganizationIdProjectsProjectIdHomeRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdHomeRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdMcpGatewaysRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdMcpGatewaysRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRouteWithChildren
  AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRouteWithChildren
  AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectsRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectsRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRouteWithChildren
  AuthenticatedOrgsOrganizationIdProjectsProjectIdToolkitsRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdToolkitsRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdToolsRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdToolsRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdUserSourcesRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdUserSourcesRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdWelcomeRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdWelcomeRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdIndexRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthConnectedUsersRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthConnectedUsersRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRouteWithChildren
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRouteWithChildren
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSettingsRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSettingsRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsInvitationIdRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsInvitationIdRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectMembersRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectMembersRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsUserVerificationRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsUserVerificationRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthIndexRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsIndexRoute
  AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsIndexRoute
}

const AuthenticatedOrgsOrganizationIdProjectsProjectIdRouteChildren: AuthenticatedOrgsOrganizationIdProjectsProjectIdRouteChildren =
  {
    AuthenticatedOrgsOrganizationIdProjectsProjectIdApiKeysRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdApiKeysRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdAuditLogsRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdAuditLogsRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdBillingRouteWithChildren,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdContextualAccessRouteWithChildren,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdHomeRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdHomeRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdMcpGatewaysRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdMcpGatewaysRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdOnboardingRouteWithChildren,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdPlaygroundRouteWithChildren,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectsRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectsRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdServersRouteWithChildren,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdToolkitsRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdToolkitsRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdToolsRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdToolsRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdUserSourcesRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdUserSourcesRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdWelcomeRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdWelcomeRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdIndexRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthConnectedUsersRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthConnectedUsersRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthOauthRouteWithChildren,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSecretsRouteWithChildren,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSettingsRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthSettingsRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsInvitationIdRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsInvitationIdRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectMembersRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdProjectMembersRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsUserVerificationRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsUserVerificationRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdAuthIndexRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdInvitationsIndexRoute,
    AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdSettingsIndexRoute,
  }

const AuthenticatedOrgsOrganizationIdProjectsProjectIdRouteWithChildren =
  AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute._addFileChildren(
    AuthenticatedOrgsOrganizationIdProjectsProjectIdRouteChildren,
  )

interface AuthenticatedOrgsOrganizationIdProjectsRouteChildren {
  AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute: typeof AuthenticatedOrgsOrganizationIdProjectsProjectIdRouteWithChildren
  AuthenticatedOrgsOrganizationIdProjectsIndexRoute: typeof AuthenticatedOrgsOrganizationIdProjectsIndexRoute
}

const AuthenticatedOrgsOrganizationIdProjectsRouteChildren: AuthenticatedOrgsOrganizationIdProjectsRouteChildren =
  {
    AuthenticatedOrgsOrganizationIdProjectsProjectIdRoute:
      AuthenticatedOrgsOrganizationIdProjectsProjectIdRouteWithChildren,
    AuthenticatedOrgsOrganizationIdProjectsIndexRoute:
      AuthenticatedOrgsOrganizationIdProjectsIndexRoute,
  }

const AuthenticatedOrgsOrganizationIdProjectsRouteWithChildren =
  AuthenticatedOrgsOrganizationIdProjectsRoute._addFileChildren(
    AuthenticatedOrgsOrganizationIdProjectsRouteChildren,
  )

interface AuthenticatedOrgsOrganizationIdRouteChildren {
  AuthenticatedOrgsOrganizationIdProjectsRoute: typeof AuthenticatedOrgsOrganizationIdProjectsRouteWithChildren
  AuthenticatedOrgsOrganizationIdIndexRoute: typeof AuthenticatedOrgsOrganizationIdIndexRoute
}

const AuthenticatedOrgsOrganizationIdRouteChildren: AuthenticatedOrgsOrganizationIdRouteChildren =
  {
    AuthenticatedOrgsOrganizationIdProjectsRoute:
      AuthenticatedOrgsOrganizationIdProjectsRouteWithChildren,
    AuthenticatedOrgsOrganizationIdIndexRoute:
      AuthenticatedOrgsOrganizationIdIndexRoute,
  }

const AuthenticatedOrgsOrganizationIdRouteWithChildren =
  AuthenticatedOrgsOrganizationIdRoute._addFileChildren(
    AuthenticatedOrgsOrganizationIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedOrgsOrganizationIdRoute: typeof AuthenticatedOrgsOrganizationIdRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedOrgsOrganizationIdRoute:
    AuthenticatedOrgsOrganizationIdRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
